import marked from "marked";
import { ErrorResponse, ReleaseNoteList, ReleaseNoteRow } from "../../api";
import { releaseNoteSlice } from "../../features/RelaseNote/store";
import { commonSlice, store } from "../../store";
import { api } from "../common/make_api";
import {
    ActionType,
    ResourceType,
    StatusType,
    sendLog,
} from "../common/send_log";

export interface MarkedReleaseNoteRow extends ReleaseNoteRow {
    markedBody: string;
}

export async function getReleaseNotes(): Promise<void> {
    store.dispatch(commonSlice.actions.startLoading());

    try {
        const releaseNoteList: ReleaseNoteList = await api
            .getReleaseNoteAPI()
            .getReleaseNotes();
        const markedReleaseNotes = (releaseNoteList.releaseNotes as MarkedReleaseNoteRow[]).map(
            (note) => {
                note.markedBody = marked(note.body); // convert text to Markdown
                return note;
            }
        );
        await store.dispatch(
            releaseNoteSlice.actions.updateReleaseNotes(
                markedReleaseNotes ?? []
            )
        );

        await sendLog(
            ResourceType.RELEASE_NOTE,
            StatusType.GET_RESOURCE,
            ActionType.GET_RELEASE_NOTES
        );
        return;
    } catch (err) {
        console.log("Got this error from release_notes:", err);

        if (err.message) {
            store.dispatch(
                commonSlice.actions.setErrorMessage([err.message as string])
            );
            await store.dispatch(commonSlice.actions.showServerErrorMessage());
            return;
        }
        if (err.status && err.status == 500) {
            await store.dispatch(commonSlice.actions.showServerErrorMessage());
            return;
        }

        const res = (await (err as Response).json()) as ErrorResponse;

        if (err["status"] == 401) {
            console.log("Console is reloading...", res);
            return;
        }
        store.dispatch(commonSlice.actions.setErrorMessage([res.message!]));
        return;
    } finally {
        store.dispatch(commonSlice.actions.finishLoading());
    }
}
